module.exports = __webpack_public_path__ + "img/eccc63fabd8542e0a1e67d45ca11b977-1440.02b4c344.jpg";